import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AdminCorrectionProvider, Camp, Company } from '@lighty';
import { StorageService, TranslateService } from '@services';
import { HttpHelper } from '@helpers';
import { MediaManagerComponent } from '@components/media-manager/media-manager.component';
import { TimelineComponent } from '@components/timeline/timeline.component';
import { CommonToastService } from '@common2/services/toast.service';

@Component({
    selector: 'msc-camp-question-correction',
    templateUrl: './question.component.html'
})

export class CampQuestionCorrectionComponent {
    @ViewChild('mediaManagerTrainer') mediaManagerTrainer: MediaManagerComponent;
    @ViewChild('correctionTimeline') correctionTimeline: TimelineComponent;
    @Input() session: any;
    @Output() onUpdate: EventEmitter<any> = new EventEmitter();
    private camp: Camp;
    private company: Company;
    public loading: boolean = false;

    constructor(
        private correctionProvider: AdminCorrectionProvider,
        private storageService: StorageService,
        private toastService: CommonToastService,
        private translateService: TranslateService,
    ) { }

    ngOnInit(): void {
        this.camp = this.storageService.get('camp');
        this.company = this.storageService.get('company');
    }

    ngOnChanges(): void {
        if (this.correctionTimeline && this.correctionTimeline.ready) {
            this.correctionTimeline.contextId = this.session.id;
            this.correctionTimeline.getTimeline();
        }
    }

    addMedia(media: any): void {
        if (media) {
            this.session.correctionMedia.push(media);
        }
    }

    deleteMedia(media: any): void {
        const index = this.session.correctionMedia.indexOf(media);

        if (index !== -1) {
            this.session.correctionMedia.splice(index, 1);
        }
    }

    update(): void {
        this.loading = true;
        const params = HttpHelper.cleanParams({
            camp_id: this.camp.id,
            company_id: this.company.id,
            ratio: this.session.ratio,
            feedback: this.session.comment,
            correctionMediaIds: this.session.correctionMedia.map(media => media.id)
        });

        this.correctionProvider.update('questions', this.session.questionId, this.session.id, params).subscribe((data) => {
            this.session = data.session;
            this.toastService.onSuccess(this.translateService.instant('toast.saved'));
            this.loading = false;

            this.onUpdate.emit('question');
        });
    }

    spyQuestion(): void {
        this.session.ratio = this.session.ratio > 100 ? 100 : this.session.ratio;
    }

}
